module.exports = __webpack_public_path__ + "img/logos-apoio-eureciclo-rodape-mobile.fd9da4c5.png";